import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Drawer, FilterContext } from "dash-ui";

import FilterFields from "pages/TrackingPage/components/TrackingPageHeader/components/FilterFields/FilterFields";

const FilterDrawer = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const { setFilterState } = useContext(FilterContext);
  const [filters, setFilters] = useState<Record<string, any>>({});

  const onRequestClose = () => {
    onClose();
  };

  const onSubmit = () => {
    Object.entries(filters).forEach(([key, value]) => {
      setFilterState(key, value);
    });
    onClose();
  };

  return (
    <Drawer
      isOpen
      onRequestClose={onRequestClose}
      title={t("common:labels.filterBy") || ""}
      cancelButton={{
        title: t("common:labels.cancel"),
        onClick: onRequestClose,
      }}
      submitButton={{
        title: t("common:labels.save"),
        onClick: onSubmit,
      }}
    >
      <FilterFields
        isDrawerFilter
        setFilter={setFilters}
        newDrawerFilters={filters}
      />
    </Drawer>
  );
};

export default FilterDrawer;
